<script>
  import {
    scaleLinear,
    scaleQuantize,
    scaleSequential,
    scaleThreshold,
  } from 'd3-scale';
  import { arc as d3arc } from 'd3-shape';
  import { cumsum } from 'd3-array';
  import { hsl } from 'd3-color';
  import { interpolateInferno, schemeRdYlBu } from 'd3-scale-chromatic';
  export let players;
  const noGpColor = '#6b7280';


  const angleGlobalOffset = 0.0 * Math.PI;
  export let width = 600;
  let height = 600;

  const angleMap = {
    'rookie': (1 / 6) * 2 * Math.PI,
    'never-playoffs': (2 / 6) * 2 * Math.PI,
    'played-playoffs': (3 / 6) * 2 * Math.PI,
    'won-playoff-series': (4 / 6) * 2 * Math.PI,
    'played-finals': (5 / 6) * 2 * Math.PI,
    'won-finals': (6 / 6) * 2 * Math.PI,
  };
  const labelMap = {
    'rookie': 'Rookies',
    'never-playoffs': 'Regular Season',
    'played-playoffs': 'Made Playoffs',
    'won-playoff-series': 'Won a Series',
    'played-finals': 'Made Finals',
    'won-finals': 'Champions',
  };
  

  const margin = { top: 10, right: 10, bottom: 10, left: 10 };
  const innerRadius = 20;
  const ringMargin = 5;
  const refRingMargin = ringMargin * 4;

  function darkerColor(color) {
    let c = hsl(color);
    c.l -= 0.05;
    c.s -= 0.05;
    return c.toString();
  }

  function lighterColor(color) {
    let c = hsl(color);
    c.l += 0.2;
    c.s += 0.2;
    return c.toString();
  }

  function glowColor(color, factor = 1) {
    let c = hsl(color);
    c.l += factor * 0.02;
    c.s += factor * 0.02;
    return c.toString();
  }
  // based on games played
  let thicknessScale = scaleLinear().domain([0, 1000]).range([2, 10]);
  const maxThickness = thicknessScale.range()[1];
  // thicknessScale = (d) => 4;
  const thicknessKey = 'career_gp';
  const colorScale = scaleThreshold()
    .domain([0.5, 0.6]) // 60%+ is roughly 85th percentil, 50% is roughly 54th percentile
    .range(['#2d3467', '#3c9245', '#f9ce1a'])
    .range(['#0d478a', '#1c9a8b', '#f9ce1a'])
    .range(['#0d478a', '#9e8667', '#f9ce1a'])
    .range(['#992B3D', '#0d478a', '#24C79E'])
    .range(['#cc002f', '#df7f45', '#eecb61'])
    .range(['#912d2c', '#d88130', '#fbe254'])
    .range(['#edf8b1', '#7fcdbb', '#2c7fb8'])
    .range(['#fff58d', '#5bb68f', '#00649f'].reverse())

  const blockWidth = 100;
  const blockHeight = 8;

  const core5 = players.slice(0, 5);
  const rest = players.slice(5);
  </script>

  <style>
    .item { 
      white-space: nowrap;
      display: flex;
      align-items: center;
      line-height: 1.6;
    }

    .icon-item {
      margin-right: 0.6ch;
      width: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    svg.icon-item {
      margin-top: -2px;
    }

    .name {
      font-size: 10px;
      letter-spacing: 0.5px;
      color: #6462A1;
      text-transform: uppercase;
    }
  
    .divider {
      margin: 8px 0;
      border-top: 1px solid hsla(229deg, 69%, 35%, 0.5);
    }
  </style>

  <div>
    <div class="core5">
    {#each core5 as player, i}
    <div class="item">
      {#if player.playoff_status === 'won-finals'}
      <svg class="icon-item" width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.95135" cy="3.81872" r="2.95135" fill={colorScale(player.career_win_pct)}/>
        <path d="M6.96225 6.77008H1.74063L3.32982 14.1106H0.908203V14.8674H7.4163V14.1106H6.35685L6.96225 6.77008Z" fill={colorScale(player.career_win_pct)}/>
        </svg>
        
      {:else}
        <div class="icon-item"><div style="border-radius: 5px; width: 5px; height: 5px; background-color: {player.career_gp === 0 ? noGpColor : colorScale(player.career_win_pct)};"></div></div>
      {/if}
      <div class="name">{player.name}</div>
    </div>
    {/each}
  </div>
  <div class="divider">
  </div>
  <div class="rest">
    {#each rest as player, i}
    <div class="item">
      {#if player.playoff_status === 'won-finals'}
      <svg class="icon-item" width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.95135" cy="3.81872" r="2.95135" fill={colorScale(player.career_win_pct)}/>
        <path d="M6.96225 6.77008H1.74063L3.32982 14.1106H0.908203V14.8674H7.4163V14.1106H6.35685L6.96225 6.77008Z" fill={colorScale(player.career_win_pct)}/>
        </svg>
        
      {:else}
        <div class="icon-item"><div style="border-radius: 5px; width: 5px; height: 5px; background-color: {player.career_gp === 0 ? noGpColor : colorScale(player.career_win_pct)};"></div></div>
      {/if}
      <div class="name">{player.name}</div>
    </div>
    {/each}
  </div>

  </div>